
export default class StyleGuideReactController {

}
